import { Box, Flex, Text, Grid, VStack, Avatar } from "@chakra-ui/react";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditProfileDrawer from "../component/EditProfileDrawer";

const Accounts = () => {
  const [editingProfile, setEditingProfile] = useState(false);
  // const [editingContactDetails, setEditingContactDetails] = useState(false);
  // const [editingPaymentDetails, setEditingPaymentDetails] = useState(false);

  return (
    <Grid templateColumns="0.6fr auto 1fr" sx={{ height: "100%" }}>
      <Box p="8">
        <Box my="8">
          <VStack spacing={6} align="stretch">
            <Text sx={{ fontWeight: 600, fontSize: "22px" }}>
              Account Settings
            </Text>
            <Text sx={{ fontSize: "20px" }}>Manage your account</Text>
          </VStack>
        </Box>

        <Box as="form">
          <VStack spacing={4} align="stretch">
            <Flex
              sx={{
                borderRadius: "8px",
                border: "1px solid #00A2E8",
                padding: "3",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setEditingProfile(true)}
            >
              <FontAwesomeIcon icon={faCalendar} />
              <Text pl="3">Profile</Text>
            </Flex>
            <EditProfileDrawer
              isOpen={editingProfile}
              onClose={() => setEditingProfile(false)}
            />

            <Flex
              sx={{
                borderRadius: "8px",
                border: "1px solid #00A2E8",
                padding: "3",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCalendar} />
              <Text pl="3">Contact Details</Text>
            </Flex>

            <Flex
              sx={{
                borderRadius: "8px",
                border: "1px solid #00A2E8",
                padding: "3",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCalendar} />
              <Text pl="3">Payment Details</Text>
            </Flex>

            <Flex
              sx={{
                borderRadius: "8px",
                border: "1px solid #00A2E8",
                padding: "3",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faCalendar} />
              <Text pl="3">Personalize Account</Text>
            </Flex>
          </VStack>
        </Box>
      </Box>

      <Box sx={{ width: "2px", height: "100%", bg: "#F6F7FB" }}></Box>

      <Box p="10">
        <Flex sx={{ justifyContent: "Center", textAlign: "center" }}>
          <Box>
            <Avatar bg="teal.500" size="xl" />
            <Text mt="10" sx={{ fontWeight: "600", fontSize: "24px" }}>
              University of Essex
            </Text>
            <Text my="5">Education</Text>

            <Box
              py="4"
              px="6"
              sx={{ border: "1px solid #00A2E8", borderRadius: "4px" }}
            >
              <Text sx={{ fontWeight: "550" }}>90875324880</Text>
              <Text>Organisation ID</Text>
            </Box>
          </Box>
        </Flex>
      </Box>
    </Grid>
  );
};

export default Accounts;
